/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Claims_DescriptionInputs */

const en_dashboard_claims_description = /** @type {(inputs: Dashboard_Claims_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View your policy documents and submit your claim online. Attach your supporting documents: medical records and invoices for medical treatments.`)
};

const fr_dashboard_claims_description = /** @type {(inputs: Dashboard_Claims_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultez vos documents de police et soumettez votre réclamation en ligne. Joignez vos pièces justificatives : dossiers médicaux et factures de traitements médicaux.`)
};

/**
* | output |
* | --- |
* | "View your policy documents and submit your claim online. Attach your supporting documents: medical records and invoices for medical treatments." |
*
* @param {Dashboard_Claims_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_claims_description = /** @type {((inputs?: Dashboard_Claims_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Claims_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_claims_description(inputs)
	return fr_dashboard_claims_description(inputs)
});